import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  ref: "newCarModalRef",
  id: "kt_modal_add_car",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header px-5 py-\"><div class=\"w-100 mx-lg-15 d-flex justify-content-between align-items-center\"><h2 class=\"fs-2 fw-bold\">Vehículo a cuenta</h2><div class=\"btn btn-sm btn-icon btn-active-color-primary\" data-bs-dismiss=\"modal\"><i class=\"isax-close-circle fs-2x text-white\"></i></div></div></div>", 1)
const _hoisted_5 = { class: "modal-body scroll-y mx-5 mx-xl-15 mb-7" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "mb-5" }, " Tomamos tu vehículo a cuenta, ayúdanos con los siguientes datos: ", -1)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-lg-12" }
const _hoisted_9 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Marca")
], -1)
const _hoisted_11 = { class: "position-relative" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", {
  value: "1",
  selected: "",
  disabled: ""
}, "Selecciona una marca", -1)
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "fv-plugins-message-container" }
const _hoisted_15 = { class: "fv-help-block" }
const _hoisted_16 = { class: "col-lg-12" }
const _hoisted_17 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Modelo")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", {
  value: "1",
  selected: "",
  disabled: ""
}, "Selecciona un modelo", -1)
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "required fw-bold form-label mb-2" }, "Año", -1)
const _hoisted_25 = { class: "position-relative" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", {
  value: "1",
  selected: "",
  disabled: ""
}, "Selecciona un año", -1)
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "fv-plugins-message-container" }
const _hoisted_29 = { class: "fv-help-block" }
const _hoisted_30 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "required fw-bold form-label mb-2" }, "Versión", -1)
const _hoisted_32 = { class: "position-relative" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("option", {
  value: "1",
  selected: "",
  disabled: ""
}, "Selecciona una version", -1)
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "fv-plugins-message-container" }
const _hoisted_36 = { class: "fv-help-block" }
const _hoisted_37 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "required fw-bold form-label mb-2" }, "Kilometraje aproximado", -1)
const _hoisted_39 = { class: "position-relative" }
const _hoisted_40 = { class: "fv-plugins-message-container" }
const _hoisted_41 = { class: "fv-help-block" }
const _hoisted_42 = { class: "text-center pt-5" }
const _hoisted_43 = {
  type: "reset",
  ref: "resetBtn",
  class: "d-none"
}
const _hoisted_44 = {
  ref: "submitButtonRef",
  type: "submit",
  id: "kt_modal_add_car_submit",
  class: "btn btn-primary w-100"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label fs-base" }, " Enviar información", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress fs-base" }, [
  /*#__PURE__*/_createTextVNode(" Enviando... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_47 = [
  _hoisted_45,
  _hoisted_46
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loaderClientVue = _resolveComponent("loaderClientVue")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_loaderClientVue, { showLoader: _ctx.showLoader }, null, 8, ["showLoader"]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_Form, {
            id: "kt_modal_add_car_form",
            class: "form mx-3",
            ref: "formContact",
            novalidate: "novalidate",
            autocomplete: "off",
            onSubmit: _ctx.submit,
            "validation-schema": _ctx.validationSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_Field, {
                        as: "select",
                        onChange: _ctx.getModels,
                        autocomplete: "off",
                        class: "form-select form-select-solid border-1 fs-base border-secondary",
                        name: "brand",
                        modelValue: _ctx.contactData.brand,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contactData.brand) = $event))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brands, (brand) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: brand.id,
                              value: brand.id
                            }, _toDisplayString(brand.name), 9, _hoisted_13))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["onChange", "modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_ErrorMessage, { name: "brand" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createVNode(_component_Field, {
                      as: "select",
                      onChange: _ctx.getYears,
                      autocomplete: "off",
                      class: "form-select form-select-solid border-1 fs-base border-secondary ps-5",
                      name: "model",
                      modelValue: _ctx.contactData.model,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contactData.model) = $event))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_19,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.models, (model) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: model.id,
                            value: model.id
                          }, _toDisplayString(model.name), 9, _hoisted_20))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["onChange", "modelValue"]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_ErrorMessage, { name: "model" })
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_Field, {
                    type: "text",
                    as: "select",
                    autocomplete: "off",
                    onChange: _ctx.getVersions,
                    class: "form-select form-select-solid border-1 fs-base border-secondary",
                    name: "year",
                    modelValue: _ctx.contactData.year,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contactData.year) = $event))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_26,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (year) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: year.id,
                          value: year.id
                        }, _toDisplayString(year.name), 9, _hoisted_27))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["onChange", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_ErrorMessage, { name: "year" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_Field, {
                    type: "text",
                    as: "select",
                    autocomplete: "off",
                    class: "form-select form-select-solid border-1 fs-base border-secondary",
                    name: "version",
                    modelValue: _ctx.contactData.version,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.contactData.version) = $event))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_33,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.versions, (version) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: version.id,
                          value: version.id
                        }, _toDisplayString(version.name), 9, _hoisted_34))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_ErrorMessage, { name: "version" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(_component_Field, {
                    type: "text",
                    autocomplete: "off",
                    class: "form-control form-control-solid border-1 fs-base border-secondary",
                    name: "km",
                    placeholder: "000,000 km",
                    modelValue: _ctx.contactData.km,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.contactData.km) = $event)),
                    onChange: _ctx.addKm
                  }, null, 8, ["modelValue", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createVNode(_component_ErrorMessage, { name: "km" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("button", _hoisted_43, "jeje", 512),
                _createElementVNode("button", _hoisted_44, _hoisted_47, 512)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ])
    ])
  ], 512))
}